import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { createMetadataQuery } from '../../../shared/data/gql/query/create-metadata.query';
import { ApolloQueryResult } from 'apollo-client';
import { Observable } from 'rxjs';
import { CreateMetadataResponse } from '../../../shared/data/responses/create-metadata.response';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {
  constructor(private apollo: Apollo) {}

  getMetadata(
    url: string
  ): Observable<ApolloQueryResult<CreateMetadataResponse>> {
    return this.apollo.query<CreateMetadataResponse>({
      query: createMetadataQuery,
      variables: { url }
    });
  }
}
